{
  "actions": "動作"
}
